import React, { useState, useEffect } from 'react';

const Contact = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const headerPadding = {
    paddingTop: isMobile ? '80px' : '3rem',
    paddingBottom: '3rem'
  };

  return (
    <>
      {/* Page Header */}
      <section className="section bg-theme-dark tc-light">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <div className="page-header" style={headerPadding}>
                <h1 className="title title-xl">Contact Us</h1>
                <p className="lead">
                  Have questions? We're here to help. Reach out to us and we'll get back to you as soon as possible.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="section section-contact bg-white">
        <div className="container">
          <div className="section-head text-center wide-auto-sm">
            <h2 className="title title-s4" title="Contact">Get In Touch</h2>
            <p>Any question? Reach out to us and we'll get back to you shortly.</p>
          </div>

          <div className="nk-block block-contact">
            <div className="row justify-content-center text-center">
              <div className="col-xl-8 col-lg-10">
                <ul className="contact-list contact-list-s1 flex-wrap flex-md-nowrap pdb-l">
                  <li>
                    <em className="contact-icon fas fa-phone"></em>
                    <div className="contact-text">
                      <span>0968-852-6355</span>
                    </div>
                  </li>
                  <li>
                    <em className="contact-icon fas fa-envelope"></em>
                    <div className="contact-text">
                      <span>info@ebarangay.ph</span>
                    </div>
                  </li>
                  <li>
                    <em className="contact-icon fas fa-mobile-alt"></em>
                    <div className="contact-text">
                      <span>Download App on Google Play</span>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="col-xl-8 col-lg-10">
                <div className="contact-wrap p-0">
                  <form id="contact-form" className="contact-form nk-form" action="#" method="post">
                    <div className="field-item field-item-center">
                      <input name="contact-name" type="text" className="input-line required" />
                      <label className="field-label field-label-line">Your Name</label>
                    </div>
                    <div className="field-item field-item-center">
                      <input name="contact-email" type="email" className="input-line input-line-center required email" />
                      <label className="field-label field-label-line">Your Email</label>
                    </div>
                    <div className="field-item field-item-center">
                      <textarea
                        name="contact-message"
                        className="input-line input-line-center input-textarea required"
                      ></textarea>
                      <label className="field-label field-label-line">Your Message</label>
                    </div>
                    <div className="field-wrap">
                      <button type="submit" className="btn btn-round btn-lg btn-grad">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section className="section bg-light pb-0">
        <div className="container">
          <div className="section-head text-center wide-auto-sm">
            <h2 className="title title-s4" title="FAQS">Frequently Asked Questions</h2>
            <p>
              Below we've provided answers about EBARANGAY, its services, and features. If you have any other questions,
              please get in touch using the contact form above.
            </p>
          </div>

          <div className="nk-block overflow-hidden">
            <div className="row justify-content-center">
              <div className="col-xl-8 col-lg-10">
                <ul className="nav tab-nav tab-nav-line mgb-r">
                  <li>
                    <a className="active" data-bs-toggle="tab" href="#general-questions">
                      General
                    </a>
                  </li>
                  <li>
                    <a data-bs-toggle="tab" href="#services-questions">
                      Services
                    </a>
                  </li>
                  <li>
                    <a data-bs-toggle="tab" href="#app-questions">
                      Mobile App
                    </a>
                  </li>
                  <li>
                    <a data-bs-toggle="tab" href="#security-questions">
                      Security
                    </a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div className="tab-pane fade show active" id="general-questions">
                    <div className="accordion accordion-s1 accordion-faq" id="faq-general">
                      <div className="accordion-item accordion-item-s4 bg-white">
                        <h5 className="accordion-title" data-bs-toggle="collapse" data-bs-target="#faq-g-1">
                          What is EBARANGAY?
                          <span className="accordion-icon accordion-icon-s2"></span>
                        </h5>
                        <div id="faq-g-1" className="collapse show" data-bs-parent="#faq-general">
                          <div className="accordion-content">
                            <p>
                              EBARANGAY is a cloud-based and secured digital platform designed to modernize barangay
                              operations. It connects desktop and mobile applications to manage resident records,
                              services, patrol monitoring, and smart surveillance in real-time.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item accordion-item-s4 bg-white">
                        <h5 className="accordion-title collapsed" data-bs-toggle="collapse" data-bs-target="#faq-g-2">
                          How do I access EBARANGAY services?
                          <span className="accordion-icon accordion-icon-s2"></span>
                        </h5>
                        <div id="faq-g-2" className="collapse" data-bs-parent="#faq-general">
                          <div className="accordion-content">
                            <p>
                              You can access EBARANGAY services through our mobile app (available on Google Play) or
                              through the desktop application. Download the app, create an account, and start requesting
                              services.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item accordion-item-s4 bg-white">
                        <h5 className="accordion-title collapsed" data-bs-toggle="collapse" data-bs-target="#faq-g-3">
                          Who can use EBARANGAY?
                          <span className="accordion-icon accordion-icon-s2"></span>
                        </h5>
                        <div id="faq-g-3" className="collapse" data-bs-parent="#faq-general">
                          <div className="accordion-content">
                            <p>
                              EBARANGAY is available for all barangay residents and officials. Residents can request
                              services and file reports, while barangay officials can manage operations and monitor
                              activities.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="tab-pane fade" id="services-questions">
                    <div className="accordion accordion-s1 accordion-faq" id="faq-services">
                      <div className="accordion-item accordion-item-s4 bg-white">
                        <h5 className="accordion-title" data-bs-toggle="collapse" data-bs-target="#faq-s-1">
                          What services are available?
                          <span className="accordion-icon accordion-icon-s2"></span>
                        </h5>
                        <div id="faq-s-1" className="collapse show" data-bs-parent="#faq-services">
                          <div className="accordion-content">
                            <p>
                              EBARANGAY offers barangay clearances, business permits, blotters, complaints filing, special
                              permits, and pet registrations. All services can be requested through the mobile app or
                              desktop application.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item accordion-item-s4 bg-white">
                        <h5 className="accordion-title collapsed" data-bs-toggle="collapse" data-bs-target="#faq-s-2">
                          How long does it take to process requests?
                          <span className="accordion-icon accordion-icon-s2"></span>
                        </h5>
                        <div id="faq-s-2" className="collapse" data-bs-parent="#faq-services">
                          <div className="accordion-content">
                            <p>
                              Processing times vary by service type. You can track your request status in real-time through
                              the app and receive notifications when your documents are ready for pickup or delivery.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="tab-pane fade" id="app-questions">
                    <div className="accordion accordion-s1 accordion-faq" id="faq-app">
                      <div className="accordion-item accordion-item-s4 bg-white">
                        <h5 className="accordion-title" data-bs-toggle="collapse" data-bs-target="#faq-a-1">
                          How do I download the EBARANGAY app?
                          <span className="accordion-icon accordion-icon-s2"></span>
                        </h5>
                        <div id="faq-a-1" className="collapse show" data-bs-parent="#faq-app">
                          <div className="accordion-content">
                            <p>
                              The EBARANGAY mobile app is available for download on the Google Play Store. Simply search
                              for "EBARANGAY" or click the download button on our website.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item accordion-item-s4 bg-white">
                        <h5 className="accordion-title collapsed" data-bs-toggle="collapse" data-bs-target="#faq-a-2">
                          Is the app free to use?
                          <span className="accordion-icon accordion-icon-s2"></span>
                        </h5>
                        <div id="faq-a-2" className="collapse" data-bs-parent="#faq-app">
                          <div className="accordion-content">
                            <p>
                              Yes, the EBARANGAY mobile app is completely free to download and use. All barangay residents
                              can access the platform at no cost.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="tab-pane fade" id="security-questions">
                    <div className="accordion accordion-s1 accordion-faq" id="faq-security">
                      <div className="accordion-item accordion-item-s4 bg-white">
                        <h5 className="accordion-title" data-bs-toggle="collapse" data-bs-target="#faq-sec-1">
                          Is my data secure on EBARANGAY?
                          <span className="accordion-icon accordion-icon-s2"></span>
                        </h5>
                        <div id="faq-sec-1" className="collapse show" data-bs-parent="#faq-security">
                          <div className="accordion-content">
                            <p>
                              Yes, EBARANGAY uses secure cloud-based technology to protect your data. We implement
                              industry-standard security measures to ensure data privacy and smooth synchronization across
                              all devices.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item accordion-item-s4 bg-white">
                        <h5 className="accordion-title collapsed" data-bs-toggle="collapse" data-bs-target="#faq-sec-2">
                          How is my personal information protected?
                          <span className="accordion-icon accordion-icon-s2"></span>
                        </h5>
                        <div id="faq-sec-2" className="collapse" data-bs-parent="#faq-security">
                          <div className="accordion-content">
                            <p>
                              Your personal information is encrypted and stored securely in our cloud database. We follow
                              strict data protection protocols and only authorized barangay officials can access your
                              information.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Download Section */}
      <section className="section bg-white pb-0">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="nk-block-img">
                <img src="/images/light/gfx-z-c.png" alt="EBARANGAY App" className="w-100" />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="nk-block-text">
                <h2 className="title mb-3">Get the EBARANGAY App</h2>
                <p className="lead mb-4">
                  Download the EBARANGAY mobile app and access all barangay services from your smartphone. Available now
                  on Google Play Store.
                </p>

                <ul className="list list-dot mb-4">
                  <li>Easy access to all barangay services</li>
                  <li>Real-time notifications and updates</li>
                  <li>Track your requests and applications</li>
                  <li>Secure and user-friendly interface</li>
                  <li>24/7 availability</li>
                </ul>

                <a
                  href="https://play.google.com/store"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download-btn"
                >
                  <em className="fab fa-google-play fa-2x me-3"></em>
                  <div>
                    <small>GET IT ON</small>
                    <br />
                    <strong>Google Play</strong>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
